import { HistoryLocation } from 'ia-react-core/~/interfaces/HistoryLocation';
import Action from '../_Action';

export default class UpdateLocation extends Action {
  /** The action namespace */
  static namespace = 'Core/Router';

  static type = 'Core/Router/UpdateLocation';

  location: string | HistoryLocation;
  method: 'push' | 'replace';
  state: unknown;

  constructor(location: string | HistoryLocation, state?: unknown, method: 'push' | 'replace' = 'push') {
    super();
    this.type = `${(this.constructor as typeof UpdateLocation).type}`;
    this.location = location;
    this.state = state;
    this.method = method;
  }
}
